import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {ExternalLinkIframeBox} from "./boxes/external-link-iframe.box";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {CyClass} from "../../../common/cy-classes";
import Device from "../../../sdk/src/utils/device/device";
import {ExternalLinkIframeContainerBox} from "./boxes/external-link-iframe-container.box";
import {ExternalLinkCloseButtonWrapperBox} from "./boxes/external-link-close-button-wrapper.box";


interface ExternalLinkIframeComponentProps {
    url: string;
    dialogHandler: IModalDialogHandler;
    maxWidth: () => number;
    maxHeight: () => number;
    onIframeCreated: (element: HTMLIFrameElement) => void;
    hideCloseButton: boolean;
    id: string;
    scrolling?: "auto" | 'no'
}

@observer
export class ExternalLinkIframeComponent extends OrbitComponent<ExternalLinkIframeComponentProps> {

    private _captureIframeElementRef = (element: HTMLIFrameElement) => {
        this.props.onIframeCreated(element);
    }

    private _onCloseClick = () => {
        this.props.dialogHandler.close();
    }

    private _renderCloseButton = () => {
        if(this.services.device.os.isMobileOS || this.props.hideCloseButton) {
            return null;
        }

        const CloseIcon = this.services.theme.currentTheme.icons.closeIcon;

        return (
            <ExternalLinkCloseButtonWrapperBox className={CyClass('cy-modal-dialog-x-close-button')} onClick={this._onCloseClick}>
                <CloseIcon size={1.6} />
            </ExternalLinkCloseButtonWrapperBox>
        );
    }

    render() {
        return (
            <ExternalLinkIframeContainerBox maxWidth={this.props.maxWidth()}
                                            maxHeight={this.props.maxHeight()}
                                            isMobileOS={this.services.device.os.isMobileOS}>

                {this._renderCloseButton()}

                <ExternalLinkIframeBox id={this.props.id}
                                       name={this.props.id}
                                       src={this.props.url}
                                       ref={this._captureIframeElementRef}
                                       frameBorder="0"
                                       scrolling={this.props.scrolling ?? "auto"}
                                       allow={Device.browser.getIframeAllowAttributeValue()}
                                       allowFullScreen={true}
                                       className={CyClass('cy-external-link-container')}/>
            </ExternalLinkIframeContainerBox>
        );
    }
}